import { TextField as MuiText, TextFieldProps } from '@material-ui/core'

 export const TextField = (opts : TextFieldProps) => {
  return (
    <MuiText fullWidth={true} {...opts} />
  )
}